<template>
  <div>
    <div class="row menubar">
      <button @click="dashboard" style="float:left;" class="no-border">
        <awesomeIcon icon="angle-left" /> <span>Terug naar overzicht</span>
      </button>
      <button v-if="all" @click="openAll" style="float:left;" class="no-border">
        <awesomeIcon icon="expand" /> <span>Alles uitklappen</span>
      </button>
      <button v-else @click="openAll" style="float:left;" class="no-border">
        <awesomeIcon icon="compress" /> <span>Alles inklappen</span>
      </button>
      <template  v-if="
        `${location}`.indexOf('http://') === 0 || `${location}`.indexOf('https://') === 0
        "
      >
        <button @click="windowPrint" style="float:left;" class="no-border">
          <awesomeIcon icon="print" />
        </button>
        <button @click="download" style="float:left;" class="no-border">
          <awesomeIcon icon="download" />
        </button>
      </template>
      <inputDropdown
        :array="groups"
        v-model="grouping"
        displayPrefix="Groepering: "
        :cb="groupingDropdownCB"
        style="float:right"
      />
      <input type="date" v-model="dateInput" class="date-input" :max="formatDate(new Date())"/>
    </div>
    <FundDetailScreen ref="fundDetails"/>

    <modalWindow v-if="infoModal" @close="infoModal = false">
      <div class="titlebar">{{ infoText.header }}</div>
      <div class="inset" v-html="infoText.text"/>
    </modalWindow>

    <div key="positions" class="card" v-if="positions !== null">
      <div v-if="Object.keys(positions).length == 0" class="msg">
        <awesomeIcon icon="exclamation-circle" /> Nog geen data!
      </div>
      <table v-else class="new click-tr">
        <thead class="table-legend">
          <tr>
            <th width="28%">
              <span @click="openModal('instrument')" class="infoButton">Instrument</span>
            </th>
            <th class="number" width="8%">
              <span @click="openModal('aantal')" class="infoButton">Aantal</span>
            </th>
            <th class="number" width="12%">
              <span @click="openModal('koers')" class="infoButton">Koers</span>
            </th>
            <th class="number" width="5%">
              <span @click="openModal('valuta')" class="infoButton">Valuta</span>
            </th>
            <th class="number" width="12%">
              <span @click="openModal('waarde')" class="infoButton">Waarde</span>
            </th>
            <th class="number" width="15%">
              <span @click="openModal('aanschafwaarde')" class="infoButton">Aanschafwaarde</span>
            </th>
            <th class="number" width="12%">
              <span @click="openModal('resultaat')" class="infoButton">Resultaat (&euro;)</span>
            </th>
            <th class="number" width="8%">
              <span @click="openModal('weging')" class="infoButton">Weging</span>
            </th>
          </tr>
        </thead>
        <tbody
          v-for="(rows, category) in groupBy(filter(positions, noZeros), grouping)"
          :key="category.id"
        >
          <tr
            @click="show[category] = !show[category]"
            :class="[ show[category] ? 'open' : 'close']"
          >
            <th v-if="!show[category]"><awesomeIcon icon="plus" /> {{ category }}</th>
            <th v-if="!show[category]" colspan="3"></th>
            <th v-if="!show[category]" class="number">
              &euro; {{ formatPrice(sumBy(rows, "worth"), true) }}
            </th>
            <th v-if="!show[category]" class="number">
              &euro; {{ formatPrice(sumBy(rows, "purchaseCost"), true) }}
            </th>
            <th
              v-if="!show[category]"
              class="number"
              :class="{
                green: sumBy(rows, 'result').toFixed(0) > 0,
                red: sumBy(rows, 'result').toFixed(0) < 0
              }"
            >
              <span v-if="sumBy(rows, 'result').toFixed(0) > 0">+</span>
              {{ formatPrice(sumBy(rows, "result"), true) }}
            </th>
            <th v-if="!show[category]" class="number">
              {{ formatPrice((sumBy(rows, "worth") * 100) / total) }}%
            </th>
          </tr>
          <tr class="sub-table">
            <td colspan="8">
              <div class="slide-wrapper" :class="{ slide: show[category] }">
                <table>
                  <tr
                    class="hide-text"
                    @click="show[category] = !show[category]"
                    :class="{ active: show[category] }"
                    v-if="show[category]"
                  >
                    <th width="28%"><awesomeIcon icon="minus" /> {{ category }}</th>
                    <th class="number" width="8%">Aantal</th>
                    <th class="number" width="12%">Koers</th>
                    <th class="number" width="5%">Valuta</th>
                    <th class="number" width="12%">Waarde</th>
                    <th class="number" width="15%">Aanschafwaarde</th>
                    <th class="number" width="12%">Resultaat</th>
                    <th class="number" width="8%">Weging</th>
                  </tr>
                  <tr
                    v-for="pos in rows"
                    @click="openFundDetailScreen(pos.id)"
                    :key="pos.id"
                  >
                    <td>
                      <span
                        v-if="
                          pos.original_class != pos.new_class && pos.original_class != 'Aandelen'
                        "
                      >
                        <awesomeIcon icon="level-up-alt" style="transform: rotate(90deg);" />
                        &nbsp;
                      </span>{{ pos.name == "COUPON" ? "Opgelopen Rente" : pos.name }}
                    </td>
                    <td class="number">
                      {{
                        formatPrice(
                          pos.obli ? pos.quantity * 100 : pos.quantity,
                          pos.quantity % 1 === 0,
                          pos.original_class == "Valutas" || pos.original_class == "Coupons" ? 2 : 4
                        )
                      }}
                    </td>
                    <td class="number">
                      {{ formatPrice(pos.rate / pos.currency_rate) }}
                    </td>
                    <td class="number">
                      <a
                        :title="
                          pos.currency !== 'EU'
                            ? '1 ' + pos.currency + ' = ' + pos.currency_rate + ' EU'
                            : ''
                        "
                        >{{ pos.currency }}</a
                      >
                    </td>
                    <td class="number">
                      <span class="mobile-result" :class="{
                        green: pos.result.toFixed(0) > 0,
                        red: pos.result.toFixed(0) < 0
                      }">
                        {{pos.result.toFixed(0) > 0 ? '+' : ''}}{{ formatPrice(pos.result, true) }}
                      </span>
                      &euro; {{ formatPrice(pos.worth, true) }}
                    </td>
                    <td class="number">&euro; {{ formatPrice(pos.purchaseCost, true) }}</td>
                    <td
                      class="number"
                      :class="{
                        green: pos.result.toFixed(0) > 0,
                        red: pos.result.toFixed(0) < 0
                      }"
                    >
                      <span v-if="pos.result.toFixed(0) > 0">+</span
                      >{{ formatPrice(pos.result, true) }}
                    </td>
                    <td class="number">{{ formatPrice((pos.worth * 100) / total) }}%</td>
                  </tr>
                  <tr v-if="show[category]" :key="category.id" class="ender">
                    <th>Subtotaal</th>
                    <th colspan="3"/>
                    <th class="number">
                      <span class="mobile-result" :class="{
                        green: sumBy(rows, 'result').toFixed(0) > 0,
                        red: sumBy(rows, 'result').toFixed(0) < 0
                      }">
                        {{sumBy(rows, 'result').toFixed(0) > 0
                        ? '+'
                        : ''}}{{ formatPrice(sumBy(rows, 'result').toFixed(0), true) }}
                      </span>
                      &euro; {{ formatPrice(sumBy(rows, "worth"), true) }}
                    </th>
                    <th class="number">
                      &euro; {{ formatPrice(sumBy(rows, "purchaseCost"), true) }}
                    </th>
                    <th
                      class="number"
                      :class="{
                        green: sumBy(rows, 'result').toFixed(0) > 0,
                        red: sumBy(rows, 'result').toFixed(0) < 0
                      }"
                    >
                      <span v-if="sumBy(rows, 'result').toFixed(0) > 0">+</span
                      >{{ formatPrice(sumBy(rows, "result"), true) }}
                    </th>
                    <th class="number">
                      {{ formatPrice((sumBy(rows, "worth") * 100) / total) }}%
                    </th>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot class="table-total">
          <tr>
            <th>Totaal</th>
            <th colspan="3"></th>
            <th class="number">
              <span
                class="mobile-result"
                :class="{
                  green: sumBy(positions, 'result').toFixed(0) > 0,
                  red: sumBy(positions, 'result').toFixed(0) < 0
                }"
              >
                {{
                  sumBy(positions, 'result').toFixed(0) > 0
                  ? '+'
                  : ''}}{{ formatPrice(sumBy(positions, 'result').toFixed(0), true) }}
              </span>
               &euro; {{ formatPrice(sumBy(positions, "worth"), true) }}
            </th>
            <th class="number">
              &euro; {{ formatPrice(sumBy(positions, "purchaseCost"), true) }}
            </th>
            <th
              class="number"
              :class="{
                ' ': sumBy(positions, 'result').toFixed(0) > 0,
                red: sumBy(positions, 'result').toFixed(0) < 0
              }"
            >
              <span v-if="sumBy(positions, 'result').toFixed(0) > 0">+</span
              >{{ formatPrice(sumBy(positions, "result"), true) }}
            </th>
            <th class="number">100,00%</th>
          </tr>
        </tfoot>
        <tbody class="table-legend fixed" v-if="scrolled">
          <tr>
            <th width="28%">
              <span @click="openModal('instrument')" class="infoButton">Instrument</span>
            </th>
            <th class="number" width="8%">
              <span @click="openModal('aantal')" class="infoButton">Aantal</span>
            </th>
            <th class="number" width="12%">
              <span @click="openModal('koers')" class="infoButton">Koers</span>
            </th>
            <th class="number" width="5%">
              <span @click="openModal('valuta')" class="infoButton">Valuta</span>
            </th>
            <th class="number" width="12%">
              <span @click="openModal('waarde')" class="infoButton">Waarde</span>
            </th>
            <th class="number" width="15%">
              <span @click="openModal('aanschafwaarde')" class="infoButton">Aanschafwaarde</span>
            </th>
            <th class="number" width="12%">
              <span @click="openModal('resultaat')" class="infoButton">Resultaat (&euro;)</span>
            </th>
            <th class="number" width="8%">
              <span @click="openModal('weging')" class="infoButton">Weging</span>
            </th>
          </tr>
        </tbody>
      </table>
      <i class="grey" v-if="positions[0]" style="float: right">
        Posities van {{ (new Date(positions[0].date)).toLocaleDateString() }}
      </i>
    </div>
    <div key="loader" v-else class="loader">
    </div>
  </div>
</template>

<script>
import {
  sumBy,
  each,
  groupBy,
  findIndex,
  filter,
} from 'lodash-es';
import FileSaver from 'file-saver';
import FundDetailScreen from './FundDetailScreen';

export default {
  name: 'UserPositions',
  components: {
    FundDetailScreen,
  },
  data() {
    return {
      show: [],
      all: true,
      infoModal: false,
      infoText: {},
      scrolled: false,
      positions: null,
      dateInput: this.formatDate(new Date()),
      total: 0,
      groups: [
        {
          label: 'Type',
          value: 'new_class',
        },
        {
          label: 'Sector',
          value: 'sector',
        },
        {
          label: 'Valuta',
          value: 'currency',
        },
        {
          label: 'Beurs',
          value: 'country',
        },
      ],
      location: window.location,
    };
  },
  computed: {
    dates() {
      const dates = {};
      const date = new Date();
      for (let i = 0; i < 31; i += 1) {
        dates[date] = date.toLocaleDateString();
        date.setDate(date.getDate() - 7);
      }
      return dates;
    },
    role() {
      return this.$store.state.role;
    },
    port() {
      return this.$store.state.currentPort;
    },
    grouping: {
      get() {
        return this.$store.state.currentPortGrouping;
      },
      set(value) {
        this.$store.state.currentPortGrouping = value;
      },
    },
  },
  watch: {
    port() {
      this.getPositions();
    },
    dateInput() {
      this.getPositions();
    },
  },
  created() {
    this.getPositions();
    document.querySelector('#mainview').addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    document.querySelector('#mainview').addEventListener('scroll', this.handleScroll);
  },
  methods: {
    filter,
    sumBy,
    groupBy,
    openModal(type) {
      if (type === 'instrument') {
        this.infoText = {
          header: 'Instrument',
          text: `De naam van de belegging. Door op de belegging te klikken, ziet u meer
          informatie.`,
        };
      } else if (type === 'aantal') {
        this.infoText = {
          header: 'Aantal',
          text: `Aantal stukken per belegging, eventueel afgerond op 4 cijfers achter de komma. Bij
          obligaties wordt het aantal aangeduid als het uitgeleende bedrag.`,
        };
      } else if (type === 'koers') {
        this.infoText = {
          header: 'Koers',
          text: `De waarde van de belegging per stuk in de getoonde valuta. Deze koers is de
          slotprijs van de voorgaande handelsdag. Bij obligaties wordt de waarde aangeduid als een
          percentage.`,
        };
      } else if (type === 'valuta') {
        this.infoText = {
          header: 'Valuta',
          text: `De valuta waarin de koers van de belegging is genoteerd. Als je op de valuta wijst
          kunt u de gebruikte wisselkoers inzien. De wisselkoers wordt een keer per dag geüpdatet.`,
        };
      } else if (type === 'waarde') {
        this.infoText = {
          header: 'Waarde',
          text: `De waarde die u hier ziet is de huidige waarde van de belegging. Dit is het aantal
          x de huidig koers. De koers is de slotprijs van de voorgaande handelsdag.`,
        };
      } else if (type === 'aanschafwaarde') {
        this.infoText = {
          header: 'Aanschafwaarde',
          text: `De waarde die u hier ziet is de som van waarden van alle losse aan- en verkopen in
          de betreffende belegging.<br /><br />Bijvoorbeeld: koop (100 x 5 euro) +  koop (200 x 2
          euro) + verkoop (-100 x 3 euro) = 500 + 400 - 300 = 600 euro.`,
        };
      } else if (type === 'resultaat') {
        this.infoText = {
          header: 'Resultaat',
          text: `De waarde die u hier ziet, is het verschil tussen de gemiddelde aanschafwaarde en
          de huidige waarde van de betreffende belegging.<br /><br />In dit resultaat zit niet het
          gerealiseerde resultaat van eventuele verkopen die hebben plaatsgevonden. Voor het
          totaalresultaat van uw portefeuille verwijzen wij u naar de rapportages.`,
        };
      } else {
        this.infoText = {
          header: 'Weging',
          text: `Het percentage dat u hier ziet geeft aan hoeveel procent van de totale portefeuille
          is belegd in de betreffende belegging. `,
        };
      }
      this.infoModal = true;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1
      }-${date.getDate() < 10 ? '0' : ''}${date.getDate()
      }`;
    },
    groupingDropdownCB() {
      this.show = [];
      this.all = true;
      this.page = 0;
    },
    openFundDetailScreen(id) {
      this.$refs.fundDetails.assetId = findIndex(this.positions, (o) => o.id === id);
    },
    download() {
      const lineArray = [];
      lineArray.push(
        'hoeveelheid;aankoopprijs_per_stuk;koers;naam;klasse;sector;valuta;wisselkoers;totaal_waarde;totaal_aanschafwaarde;resultaat',
      );
      this.positions.forEach((infoArray) => {
        lineArray.push(
          `${this.formatPrice(infoArray.quantity)};${this.formatPrice(
            infoArray.purchase_rate,
          )};${this.formatPrice(infoArray.rate)};${infoArray.name};${infoArray.new_class};${
            infoArray.sector
          };${infoArray.currency};${this.formatPrice(infoArray.currency_rate)};${this.formatPrice(
            infoArray.worth,
          )};${this.formatPrice(infoArray.purchaseCost)};${this.formatPrice(infoArray.result)}`,
        );
      });
      const file = new File([lineArray.join('\n')], `${this.port}-${this.positions[0].date}.csv`, {
        type: 'text/csv;charset=utf-8',
      });
      FileSaver.saveAs(file);
    },
    noZeros(obj) {
      return obj.quantity !== 0;
    },
    openAll() {
      this.all = !this.all;
      each(groupBy(this.positions, this.grouping), (rows, category) => {
        this.show[category] = !this.all;
      });
    },
    chooseGroup(group) {
      this.$store.state.currentPortGrouping = group;
    },
    handleScroll() {
      const height = document.querySelector('#mainview').scrollTop;
      this.scrolled = height > 96;
    },
    dashboard() {
      this.$store.state.currentView = 'Dashboard';
    },
    getPositions() {
      this.positions = null;
      this.sdk.getPositions(
        this.$store.state.currentPort,
        { date: `${new Date(this.dateInput).getFullYear()}-${new Date(this.dateInput).getMonth() + 1}-${new Date(this.dateInput).getDate()}` },
        (response) => {
          if (response.status === 200) {
            for (let i = 0; i < response.data.length; i += 1) {
              if (!response.data[i].sector) {
                response.data[i].sector = 'Overige';
              }
              if (response.data[i].name === response.data[i].currency) {
                response.data[i].purchase_rate = response.data[i].rate;
              }
              response.data[i].worth = response.data[i].quantity * response.data[i].rate;
              response.data[i].purchaseCost = response.data[i].quantity
                * response.data[i].purchase_rate;
              response.data[i].result = response.data[i].worth - response.data[i].purchaseCost;
              if (
                response.data[i].original_class === 'Obligaties'
                && new RegExp('^([0-9],[0-9][0-9][0-9]%|FRN)').test(response.data[i].name)
              ) {
                response.data[i].obli = true;
              } else {
                response.data[i].obli = false;
              }
            }
            this.total = sumBy(response.data, 'worth');
            this.positions = response.data;
          } else {
            this.sdk.logout();
            window.location.reload();
          }
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.infoButton {
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    background-color: rgba(0,0,0, 0.2);
  }
}
.menubar {
  border-radius: 0;
  height: 40px;
  padding: 2px;
  box-sizing: border-box;
}
.date-input {
  width: 150px;
  height: 36px;
  float: right;
  border-radius: 0;
  margin-left: 2px;
  @media #{$mobile} {
    margin-top: 2px;
    height: -webkit-fill-available;
  }
}
.no-border {
  border-radius: 0;
}
.card {
  padding: 20px;
  border-radius: 0;
  @media #{$mobile} {
    margin-top: 40px;
    padding: 36px 2px 2px;
  }
}
.sub-table {
  padding: 0;
  border: 0;
  > td {
    padding: 0;
  }
  table {
    .hide-text {
      border-top: none;
      * {
        color: transparent;
        &:first-child {
          color: initial;
        }
      }
    }
  }
}
.open th {
  background-color: initial;
}
.close th {
  background-color: #f7f8fa;
}
.slide-wrapper {
  overflow: hidden;
  max-height: 0px;
  &.slide {
    max-height: 9999px;
  }
}
@media #{$desktop} {
  .mobile-result {
    display: none;
  }
}
@media #{$mobile} {
  td, th {
    display: none;
  }
  td:nth-child(1),
  th:nth-child(1),
  thead th:nth-child(5),
  tbody th:nth-child(3),
  tbody td:nth-child(5),
  tfoot th:nth-child(3) {
    display: table-cell;
  }
  .mobile-result {
    display: inline-block;
    margin-right: 5px;
    opacity: .5;
  }
}
</style>
